import { Stack } from "@mui/system";
import {
  Autocomplete,
  Button,
  InputAdornment,
  Paper,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import ThemeFilter from "./ThemeFilter";
import { Link as RouterLink, useSearchParams } from "react-router-dom";
import RequestNewModal from "../ThemeModal/RequestNewModal";
import { useEffect, useState } from "react";
import { CheckPermissionsDesign } from "../../../../../pages/AssetManagement/Design/CheckPermission/CheckDesignPermissions";
import { useSelector } from "react-redux";
import { selectUserData } from "../../../../../features/userSlice";
import { useDispatch } from "react-redux";
import { setSelectedTheme } from "../../../../../features/themeSlice";

function ThemeFilterCard() {
  const { selectedTheme, designThemesData } = useSelector(
    (state: any) => state?.theme
  );
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const clearSelectedTheme = () => {
    dispatch(setSelectedTheme(null));
  };

  const userData = useSelector(selectUserData);

  const [openModal, setOpenModal] = useState(false);
  const hasCreateThemeNotesPermission = CheckPermissionsDesign(
    userData?.data?.products,
    "create_theme"
  );
  const hasRequestNewDesignPermission = CheckPermissionsDesign(
    userData?.data?.products,
    "new_design_request"
  );

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  useEffect(() => {
    // Update selectedTemplate when searchParams change (e.g., on back/forward navigation)
    dispatch(setSelectedTheme(searchParams.get("search")));
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Paper sx={{ padding: "8px 16px", marginTop: "8px", boxShadow: "none" }}>
        <Stack
          flexDirection={"row"}
          justifyContent={"start"}
          gap={2}
          sx={{ padding: "16px 16px 0px 16px" }}
        >
          <Autocomplete
            data-tracker="136"
            sx={{ width: "300px" }}
            options={designThemesData?.map((item: any) => item?.name) || []}
            value={selectedTheme} // Set value to selected template
            onChange={(_, newValue) => {
              dispatch(setSelectedTheme(newValue));
              // Preserve existing search params while updating 'selectedTemplate'
              setSearchParams((prevParams) => {
                const updatedParams = Object.fromEntries(prevParams); // Preserve previous params
                if (newValue) {
                  updatedParams.search = newValue; // Set new value
                } else {
                  delete updatedParams.search; // Remove from URL if cleared
                }
                return updatedParams;
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Theme Name"
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ marginLeft: "12px" }} />
                    </InputAdornment>
                  ),
                }}
                color="secondary"
              />
            )}
            size="small"
          />
          <Stack
            flexDirection={"row"}
            justifyContent={"space-between"}
            sx={{ width: "100%" }}
          >
            <ThemeFilter clearSelectedTheme={clearSelectedTheme} />
            <Stack flexDirection={"row"} gap={2}>
              {hasRequestNewDesignPermission ? (
                <Button
                  data-tracker="138"
                  variant="outlined"
                  color="secondary"
                  sx={{ whiteSpace: "nowrap" }}
                  onClick={handleOpenModal}
                >
                  Request New Design
                </Button>
              ) : (
                <>
                  {" "}
                  <Button
                    variant="outlined"
                    disabled
                    sx={{ whiteSpace: "nowrap" }}
                  >
                    Request New Design
                  </Button>
                </>
              )}
              {hasCreateThemeNotesPermission ? (
                <RouterLink
                  to={`create_new_theme?${(() => {
                    const params = new URLSearchParams(searchParams);
                    params.set("page", "0");
                    return params.toString();
                  })()}`}
                >
                  <Button
                    data-tracker="140"
                    variant="contained"
                    color="secondary"
                    sx={{ whiteSpace: "nowrap" }}
                  >
                    <Stack flexDirection={"row"} gap={1}>
                      Create Theme <AddIcon fontSize="small" />
                    </Stack>
                  </Button>
                </RouterLink>
              ) : (
                <>
                  <Button
                    variant="contained"
                    disabled
                    sx={{ whiteSpace: "nowrap" }}
                  >
                    <Stack flexDirection={"row"} gap={1}>
                      Create Theme <AddIcon fontSize="small" />
                    </Stack>
                  </Button>
                </>
              )}
            </Stack>
          </Stack>
          <RequestNewModal open={openModal} onClose={handleCloseModal} />
        </Stack>
      </Paper>
    </>
  );
}
export default ThemeFilterCard;
